import { AxiosError } from "axios";
import { apiMain } from "@/common/services";
import { IOperation } from "@/common/services/RedGifsService";
import { IErrorData, IUserSettings } from "@/common/services/types";
import { showNotification } from "@/components/alerts/Notifications";

export const useUserSettingsHandlers = () => {
  const handleApiError = (e: unknown) => {
    const err = e as AxiosError<IErrorData>;
    const message = err.response?.data?.error?.message ||
      "An error occurred, please try again later";

    showNotification({
      title: message,
      variant: "error",
    });
  };

  const handleSuccessNotification = () => {
    showNotification({
      title: "Successfully updated!",
      variant: "success",
    });
  };

  const updateUserProfile = async (params: IOperation[]) => {
    try {
      await apiMain.updateProfileInfo(params);
      handleSuccessNotification();
    } catch (e) {
      handleApiError(e);
    }
  };

  const updateUserSettings = async (params: IUserSettings) => {
    try {
      await apiMain.updateUserSettings(params);
      handleSuccessNotification();
    } catch (e) {
      handleApiError(e);
    }
  };

  return {
    updateUserSettings,
    updateUserProfile
  };
};
